// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__141zA","rootNoMargin":"styles_rootNoMargin__wmDFf"};